<template>

  <div class="plr16 mt20 mb20">
  
  
   <div class="f-between form-title ">
         <div> <a-button class="col-theme" type="text" @click="get_user_list"><sync-outlined />刷新列表</a-button></div>
         <a-pagination v-model:current="pagenum" :total="userCount" @change="change" :defaultPageSize="pagesize" show-less-items />
       </div>

       
     <div class="listBox">
       <a-list item-layout="horizontal" :data-source="userList">
         <template #renderItem="{ item }">
           <a-list-item >
               <a-list-item-meta
                
               >
               <template #title>
      
                 <span class="info info_id">{{ item.uid }} #</span>
                 <span class="info ">{{ item.tel }}</span>
  
                 <span class="info state">总记录：{{ item.infocount }}</span>
                 <span class="info state">总积分：{{ item.income }}</span>
                 <span class="info state">总扣除：{{ item.penalty }}</span>
                 <span class="info state">总提现：{{ item.outcome }}</span>

                 
               </template>


               <template #description>

                <span class="info ">注册时间：{{ item.createtime }}</span>
                <span class="info ">注册IP：{{ item.createip }}</span>
                <span class="info ">推荐码：{{ item.promotioncode }}</span>
                <span class="info ">推荐人ID：{{ item.promotionfrom }}</span>

               </template>


              
              
             </a-list-item-meta>
           </a-list-item>
         </template>
       </a-list>
      
           
     </div>


  </div>
</template>



<script>

 import { mapActions } from "vuex"
 import { message } from 'ant-design-vue'
 import config from "@/common/config"

 export default {


   name: "user",
   data() {
     return {
      selected:null,
      pagenum:1,
      pagesize:10,
      userList:[],
      userCount:0

     }
   },
   created() {
     this.name = localStorage.getItem('name') || '-'
     this.get_user_list()


   }, 
  
   methods: {
     ...mapActions([
         'user_list'
       ]),

     change(page, pageSize){
       this.get_user_list()
     },

  
     get_user_list(){
       let token = localStorage.getItem('t') || 'xx'
       let params = {}
       
       params.token = token
       params.pagenum = this.pagenum
       params.pagesize = this.pagesize

       this.user_list(params)
         .then((dt) => {
           this.userList = dt.data
           this.userCount = dt.count
           
           
         })
         .catch((dt) => {
           this.$router.replace({
               name: 'login'
             })
           
         });


     }

   }


 };






</script>

<style scoped>

.item{

 height:40px;
 line-height:40px;
}

.width50{

width:50%
}
.devicename{
 width:60%;
 text-overflow: ellipsis; 
 overflow:hidden; 
 white-space: nowrap;
}
.announce{
 cursor: pointer;
 color: yellow;
}
.listBox {
 display: flex;
}
.ant-list {
 flex: 1;
 margin-right: 20px;
}

.info{
 margin: 0 10px;
}

</style>
